
import Vue, { PropType } from 'vue';
import Paper from '~/components/builders/Paper.vue';
import DateRange from '../components/DateRange.vue';
import OngoingBadge from '../components/OngoingBadge.vue';
import VisibilityBadge from '../components/VisibilityBadge.vue';
import Icon from '~/components/builders/Base/Icon.vue';
import VFairInvite from '../details/VFairInvite.vue';
import { VFair, VFairUser } from '~/services/VFairService';
import UserInfoService from '~/services/UserInfoService';
import AddToCalendarButton from './AddToCalendarButton.vue';
import isBefore from 'date-fns/isBefore';

export type HeaderButtonType = 'register' | 'enter' | 'calendar' | null;

export default Vue.extend({
    name: 'VFairHeader',
    components: {
        Paper,
        DateRange,
        OngoingBadge,
        VisibilityBadge,
        Icon,
        VFairInvite,
        AddToCalendarButton,
    },
    props: {
        isLoadingVFair: {
            type: Boolean,
            required: true,
        },
        isLoadingUser: {
            type: Boolean,
            default: false,
        },
        vFair: {
            type: Object as PropType<VFair | null>,
            default: null,
        },
        vFairUser: {
            type: Object as PropType<VFairUser | null>,
            default: null,
        },
        buttonType: {
            type: String as PropType<HeaderButtonType>,
            default: null,
        },
        hideButton: {
            type: Boolean,
            default: false,
        },
        isInvited: {
            type: Boolean,
            default: false,
        },
        isInterested: {
            type: Boolean,
            default: false,
        },
        hideInterestStatus: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        upcoming(): boolean {
            if (!this.vFair) return true;
            return isBefore(new Date(), this.vFair.start);
        },
    },
});
